export default {
    bank_name: 'Bank Name',
    account_number: 'Account Number',
    account_name: 'Account Name',
    amount: 'Amount',
    popup_title: 'Withdraw Money',
    popup_title_confirm: 'Confirm Withdraw Money',
};
